import { axiosInstance } from '../Config/axios';

const API_URL = 'v1/evaluations/';
const API_DELETED_URL = `v1/evaluations-deleted/`;
const CONFIG_URL = 'v1/evaluations/config/';

// Obtener todas las Evaluaciones
export const getEvaluations = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las evaluaciones:", error);
    throw error;
  }
};

// Obtener una evaluación por código
export const getEvaluationByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la evaluación con código ${code}:`, error);
    throw error;
  }
};

// Actualizar una evaluación por código
export const updateEvaluations = async (code, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la evaluación con código ${code}:`, error);
    throw error;
  }
};

//
// Obtener los tipos de ejecución
export const getExecutionTypes = async () => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}execution_type/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de ejecución", error);
    throw error;
  }
};

// Obtener las frecuencias
export const getFrequencys = async () => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}frequency/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las frecuencias", error);
    throw error;
  }
};

// Obtener el status
export const getStatus = async () => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}status/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el status", error);
    throw error;
  }
};

// Función para listar las evaluaciones eliminadas (GET)
export const getEvaluationsDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las evaluaciones eliminadas:', error);
    throw error;
  }
};

// Obtener una evaluación eliminado por código (GET)
export const getEvaluationsDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la evaluación eliminada con código ${code}:`, error);
    throw error;
  }
};